(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-support-info-kova"] && !Shopify.designMode) return;
  try {
    
(function() {
  const hoursBadge = document.getElementById('hours-badge');
  
  function updateHours() {
    const now = new Date();
    
    const dayOfWeek = now.toLocaleString('en-US', { 
      timeZone: 'America/New_York', 
      weekday: 'long' 
    });
    
    let badgeText = '';
    
    switch(dayOfWeek) {
      case 'Monday':
      case 'Tuesday':
      case 'Wednesday':
      case 'Thursday':
      case 'Friday':
        badgeText = '(9am–9pm ET)';
        break;
      case 'Saturday':
        badgeText = '(9am–6pm ET)';
        break;
      case 'Sunday':
        badgeText = 'Call Anytime';
        break;
    }
    
    hoursBadge.textContent = badgeText;
  }
  
  updateHours();
  setInterval(updateHours, 60000);
})();

  } catch(e) { console.error(e); }
})();
})();
